export const config = {
    accountServiceUrl: "https://services.dev.odyssys.net/account",
    analyticsServiceUrl: "https://services.dev.odyssys.net/analytics",
    //analyticsServiceUrl: "http://localhost:8580/analytics",

    cbuServiceUrl: "https://services.dev.odyssys.net/cbu",
    galleryUploadUrl: "https://services.dev.odyssys.net/gallery-upload",
    networkDeviceServiceUrl: "https://services.dev.odyssys.net/network-device",
    sso_redirect_uri: "https://cbu.dev.odyssys.net/callback",
    sso_authorization_url: "https://services.dev.odyssys.net/account/login-provider-configurations/6d6f2d45-acda-11e7-8b65-0612ef84a28a/authorize",
    sso_client_id: "d60bd613-acd9-11e7-8b65-0612ef84a28a",
    galleryUrl: "https://dev.odyssys.net/gallery/97124911/images",
    captivePortalServiceUrl: "https://services.dev.odyssys.net/portal"
};



// WEBPACK FOOTER //
// ./src/config.js